import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetDocumentFiltersCommand extends IRequestCommand<
  IGetDocumentFiltersParameters,
  ErrorDetails,
  IGetDocumentFiltersResponse
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'data/documents/{carrierUserId}/expiration';

  public override setParameters(parameters: IGetDocumentFiltersParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId ? parameters.carrierUserId : ''
    );
  }
}

export interface IGetDocumentFiltersParameters extends ICommandParameters {
  carrierUserId: string;
}

export interface IGetDocumentFiltersResponse extends ICommandResponse {}
